import React, { useMemo, useEffect, Fragment, useContext, useState, useRef } from 'react';
import { TelnyxRTC } from '@telnyx/webrtc';

var TelnyxRTCContext = React.createContext(null);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function useTelnyxRTC(credentialParam, clientOptions) {
  var telnyxClient = useMemo(function () {
    if (telnyxClient !== null && telnyxClient !== void 0 && telnyxClient.connected) {
      if (process.env.NODE_ENV === 'development' && telnyxClient) {
        console.warn('Instance of Telnyx Client already exists and will be disconnected.');
      }

      telnyxClient === null || telnyxClient === void 0 ? void 0 : telnyxClient.disconnect();
    }

    var session = new TelnyxRTC(_extends({
      login_token: ''
    }, credentialParam, clientOptions));
    session.on('telnyx.error', function () {
      session === null || session === void 0 ? void 0 : session.disconnect();
    });
    session.on('telnyx.socket.error', function () {
      session === null || session === void 0 ? void 0 : session.disconnect();
    });
    session === null || session === void 0 ? void 0 : session.connect();
    return session;
  }, [credentialParam]);
  useEffect(function () {
    return function () {
      telnyxClient === null || telnyxClient === void 0 ? void 0 : telnyxClient.disconnect();
    };
  }, [telnyxClient]);
  return telnyxClient;
}

function TelnyxRTCProvider(_ref) {
  var children = _ref.children,
      credential = _ref.credential,
      options = _ref.options;
  var telnyxClient = useTelnyxRTC(credential, options);
  return React.createElement(TelnyxRTCContext.Provider, {
    value: telnyxClient || null
  }, React.createElement(Fragment, null, children));
}

function useCallbacks(props) {
  var telnyxClient = useContext(TelnyxRTCContext);
  useEffect(function () {
    if (props !== null && props !== void 0 && props.onReady) {
      telnyxClient.on('telnyx.ready', props.onReady);
    }

    if (props !== null && props !== void 0 && props.onError) {
      telnyxClient.on('telnyx.error', props.onError);
    }

    if (props !== null && props !== void 0 && props.onSocketError) {
      telnyxClient.on('telnyx.socket.error', props.onSocketError);
    }

    if (props !== null && props !== void 0 && props.onSocketClose) {
      telnyxClient.on('telnyx.socket.close', props.onSocketClose);
    }

    if (props !== null && props !== void 0 && props.onNotification) {
      telnyxClient.on('telnyx.notification', props.onNotification);
    }
  }, []);
  return null;
}

function useNotification() {
  var _useState = useState(),
      notification = _useState[0],
      setNotification = _useState[1];

  useCallbacks({
    onNotification: setNotification
  });
  return notification;
}

function Media(_ref) {
  var type = _ref.type,
      stream = _ref.stream,
      props = _objectWithoutPropertiesLoose(_ref, ["type", "stream"]);

  var mediaRef = useRef();
  useEffect(function () {
    if (mediaRef.current && stream) {
      mediaRef.current.srcObject = stream;
    }
  }, [stream]);
  return React.createElement(type, _extends({
    ref: mediaRef,
    autoPlay: true
  }, props));
}

function Audio(props) {
  return React.createElement(Media, _extends({
    type: 'audio'
  }, props));
}
function Video(props) {
  return React.createElement(Media, _extends({
    type: 'video',
    playsInline: true
  }, props));
}

export { Audio, Media, TelnyxRTCContext, TelnyxRTCProvider, Video, useCallbacks, useNotification, useTelnyxRTC };
//# sourceMappingURL=index.modern.js.map
